import { push } from "connected-react-router";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { actions as servicePaymentsActions } from "reducers/servicePayments";

const PaymentsDetailPage = () => {
    const { id, hash } = useParams();
    const dispatch = useDispatch();
    const { debts, fetching } = useSelector((state) => state.servicePayments);
    const scheduledBill = debts.find((debt) => debt.hash === hash);

    useEffect(() => {
        if (debts?.length === 0) {
            dispatch(servicePaymentsActions.getDebts());
        }
    }, [dispatch]);

    return (
        <div className="service-payments__detail">
            <Notification scopeToShow="newServicePaymentPage" />
            <ResponsiveHeader defaultTitle={scheduledBill?.companyName} id={scheduledBill?.companyName} />
            <MainContainer showLoader={fetching}>
                <h2 className="service-payments__concept">{scheduledBill?.reference}</h2>
                <GridTable className="payment-details-list">
                    <GridTable.Container>
                        {scheduledBill?.details.map((detail) => (
                            <GridTable.Data key={`summary-bill-${detail.label}`}>
                                <CustomData titleText={detail.label} valueText={detail.value} />
                            </GridTable.Data>
                        ))}
                        <GridTable.Data>
                            <CustomData
                                titleText="payments.service.paymentId"
                                titleTextType="I18N"
                                valueText={scheduledBill?.serviceId}
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
                <Row className="form-actions">
                    <Col xs={12} md={4} mdOffset={4}>
                        <Button
                            className="btn-primary"
                            label="payments.service.option.pay"
                            onClick={() => dispatch(push(`/servicePayments/detail/${id}/${hash}/pay`))}
                        />
                    </Col>
                </Row>
            </MainContainer>
        </div>
    );
};

export default PaymentsDetailPage;
